import React from 'react'
import { Grid, Button, withStyles, Container, Divider } from '@material-ui/core'
import { Redirect } from 'react-router';
import ArticlesList from './ArticlesList';
import ManageUsers from '../Manage/ManageUsers';

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    button: {
        padding: `${theme.spacing(5)}px`
    },
    divider: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    }
})

class AdminDashboard extends React.Component {
    state = {
        redirectLink: null,
    }

    handleUsersClick = (e) => {
        this.setState({ redirectLink: 'manage/users' })
    }

    handleArticlesClick = (e) => {
        this.setState({ redirectLink: 'manage/articles' })
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                {this.state.redirectLink ? <Redirect to={this.state.redirectLink} /> : '' }
                <Container>
                    <Grid container spacing={2} className={classes.root}>
                        <Grid item sm={6}>
                            <Button 
                                variant="outlined"
                                color="primary"
                                onClick={this.handleUsersClick}
                                className={classes.button}>
                                Manage users
                            </Button>
                        </Grid>
                        <Grid item sm={6}>
                            <Button 
                                variant="outlined" 
                                color="primary" 
                                onClick={this.handleArticlesClick}
                                className={classes.button}>
                                Manage articles
                            </Button>
                        </Grid>
                    </Grid>
                    <Divider light className={classes.divider} />
                    <ManageUsers />
                    <Divider light className={classes.divider} />
                    <ArticlesList />
                </Container>
            </div>
        )
    }
}

export default withStyles(styles)(AdminDashboard);